export const spData = {
    "code": 200,
    "list": [
        //密码设备数
        {
            "data": [{
                "type": "身份鉴别类",
                "value": 455555,
                "name": "身份认证系统"
            }, {
                "type": "签名类",
                "value": 100,
                "name": "签名验签服务器"
            }],
            "name": "deviceTotal"
        },
        //设备利用率
        {
            "data": [{
                "name": "签名验签服务器",
                "value": 10000
            }, {
                "name": "时间戳服务器",
                "value": 20000
            }, {
                "name": "数字证书服务",
                "value": 30000
            }, {
                "name": "数据存证服务器",
                "value": 40000
            }, {
                "name": "密钥管理服务器",
                "value": 50000
            }, {
                "name": "身份认证服务器",
                "value": 60000
            }],
            "name": "deviceRate"
        },
        //当日设备调用次数
        {
            "data": [{
                "name": "签名验签服务器",
                "value": 10000
            }, {
                "name": "时间戳服务器",
                "value": 20000
            }, {
                "name": "数字证书服务",
                "value": 30000
            }, {
                "name": "数据存证服务器",
                "value": 40000
            }, {
                "name": "密钥管理服务器",
                "value": 50000
            }, {
                "name": "身份认证服务器",
                "value": 60000
            }],
            "name": "deviceCallDay"
        },
        //最近30天设备调用次数
        {
            "data": [{
                "name": "签名验签服务器",
                "value": 10000
            }, {
                "name": "时间戳服务器",
                "value": 20000
            }, {
                "name": "数字证书服务",
                "value": 30000
            }, {
                "name": "数据存证服务器",
                "value": 40000
            }, {
                "name": "密钥管理服务器",
                "value": 50000
            }, {
                "name": "身份认证服务器",
                "value": 60000
            }],
            "name": "deviceCallMonth"
        },
        //服务使用量/当日新增/租户数/应用数
        {
            "data": [{
                "name": "当日新增",
                "value": 45000
            }, {
                "name": "服务使用量",
                "value": 850000
            }, {
                "name": "租户数",
                "value": 45000
            }, {
                "name": "应用数",
                "value": 850000
            }],
            "name": "serverTotal"
        },
        //证书用量
        {
            "data": [{
                "name": "企业证书",
                "value": 850000
            }, {
                "name": "个人证书",
                "value": 150000
            }],
            "name": "certTotal"
        },
        //印章用量
        {
            "data": [{
                "name": "公章",
                "value": 850000
            }, {
                "name": "发票章",
                "value": 156000
            }],
            "name": "sealTotal"
        },
        //密钥用量
        {
            "data": [{
                "name": "公章",
                "value": 850000
            }, {
                "name": "发票章",
                "value": 150000
            }],
            "name": "keyTotal"
        },
        //平台运行态势（当日）
        {
            "data": [],
            "name": "runtimeDayTotal"
        },
        //平台运行态势（月）
        {
            "data": [{
                "name": "2023-08-13",
                "value": 1000
            }, {
                "name": "2023-08-14",
                "value": 100000
            }, {
                "name": "2023-08-15",
                "value": 1000
            }],
            "name": "runtimeMonthTotal"
        },
        //平台运行态势（周）
        {
            "data": [{
                "name": "2022-09-22",
                "value": 1000
            }, {
                "name": "2022-09-27",
                "value": 100000
            }, {
                "name": "2022-09-28",
                "value": 1000
            }],
            "name": "runtimeWeekTotal"
        },

        //告警日志
        {
            "data": [{
                "level": 1,
                "content": "签名验签服务器故障",
                "position": "陕西西安",
                "ip": "10.10.10.10",
                "wtime": "2022-09-01 00:00:00"
            }, {
                "level": 2,
                "content": "身份认证服务器故障",
                "position": "陕西西安",
                "ip": "10.10.10.10",
                "wtime": "2022-09-01 00:00:00"
            }, {
                "level": 2,
                "content": "数据存证服务器故障",
                "position": "陕西西安",
                "ip": "10.10.10.10",
                "wtime": "2022-09-01 00:00:00"
            }, {
                "level": 2,
                "content": "签名验签服务器故障",
                "position": "陕西西安",
                "ip": "10.10.10.10",
                "wtime": "2022-09-01 00:00:00"
            }, {
                "level": 2,
                "content": "服务器2故障",
                "position": "陕西西安",
                "ip": "10.10.10.10",
                "wtime": "2022-09-01 00:00:00"
            }],
            "name": "warningLogs"
        },
        //证书状态统计
        {
            "data": [{
                "name": "新办",
                "value": 1000
            }, {
                "name": "延期",
                "value": 10000
            }],
            "name": "certStatus"
        },
        //印章状态统计
        {
            "data": [{
                "name": "新办",
                "value": 1000
            }, {
                "name": "延期",
                "value": 10000
            }],
            "name": "sealStatus"
        },
        //密钥状态统计
        {
            "data": [{
                "name": "激活",
                "value": 67835
            }, {
                "name": "归档",
                "value": 7210
            }, {
                "name": "过期",
                "value": 2260
            }, {
                "name": "失信",
                "value": 5870
            }],
            "name": "KeyStatus"
        },

        //租户调用次数
        {
            "data": [{
                "name": "西安市工商",
                "value": 62232
            },
            {
                "name": "鄂尔多斯大数据",
                "value": 2
            },
            {
                "name": "陕西省大数据",
                "value": 0
            },
            {
                "name": "西安市大数据",
                "value": 0
            },
            {
                "name": "陕西省公共资源",
                "value": 0
            }],
            "name": "leaseholderRate"
        },
        //应用调用次数
        {
            "data": [{
                "name": "签名验签应用",
                "value": 1000
            }, {
                "name": "密钥管理应用",
                "value": 100000
            }],
            "name": "appRate"
        },
        // 密码服务 comTitleList
        {
            "data": [{
                name: '服务类型',
                value: '9'
            },
            {
                name: '服务天数',
                value: '150'
            },
            {
                name: '服务单位',
                value: '7'
            },
            {
                name: '服务应用',
                value: '207'
            }],
            "name": "serverTitleList"
        },
        // 密码资源 comTitleList
        {
            "data": [{
                name: '密码设备类型',
                value: '5'
            },
            {
                name: '密码设备总量',
                value: '37'
            },
            {
                name: '异常设备数量',
                value: '2',
            }],
            "name": "resourceTitleList"
        },
        // 密钥管理 comTitleList
        {
            "data": [{
                name: '对称密钥（对）',
                value: '2444'
            },
            {
                name: '非对称密钥（对）',
                value: '3548'
            },
            {
                name: '签名证书（张）',
                value: '2000'
            },
            {
                name: '加密证书（张）',
                value: '1500'
            }],
            "name": "keyTitleList"
        },
        // 应用系统 comTitleList
        {
            "data": [{
                name: '租户/单位（家）',
                value: '5'
            },
            {
                name: '应用系统（个）',
                value: '150'
            }],
            "name": "appTitleList"
        },
        // 密码服务--- 密码服务能力使用情况
        {
            "data": [{
                "name": "密码计算",
                "value": 70
            }, {
                "name": "网络负载",
                "value": 87
            }],
            "name": "serverUsage"
        },
        // 实时密码服务调用次数
        {
            "data": [{
                "name": "10:10:00",
                "value": 205
            }, {
                "name": "10:10:10",
                "value": 181
            }, {
                "name": "10:10:20",
                "value": 176
            }, {
                "name": "10:10:30",
                "value": 165
            }, {
                "name": "10:10:40",
                "value": 143
            }, {
                "name": "10:10:50",
                "value": 132
            }, {
                "name": "10:10:60",
                "value": 122
            }, {
                "name": "10:11:00",
                "value": 119
            }, {
                "name": "10:11:10",
                "value": 106
            }, {
                "name": "10:11:20",
                "value": 103
            }, {
                "name": "10:11:30",
                "value": 101
            }],
            "name": "serverCallSecond"
        },
        // 密码服务使用时长
        {
            "data": [{
                "name": "协同签名服务",
                "value": 257
            }, {
                "name": "时间戳服务",
                "value": 246
            }, {
                "name": "数字证书服务",
                "value": 244
            }, {
                "name": "身份认证服务",
                "value": 186
            }, {
                "name": "签名验签服务",
                "value": 175
            }, {
                "name": "密钥管理服务",
                "value": 164
            }, {
                "name": "电子签章服务",
                "value": 155
            }, {
                "name": "动态令牌服务",
                "value": 146
            }, {
                "name": "数据存证服务",
                "value": 140
            }],
            "name": "serverUsageDuration"
        },
        // 密码服务接入应用数量
        {
            "data": [{
                "name": "协同签名服务",
                "value": 543
            }, {
                "name": "时间戳服务",
                "value": 467
            }, {
                "name": "数字证书服务",
                "value": 433
            }, {
                "name": "身份认证服务",
                "value": 376
            }, {
                "name": "签名验签服务",
                "value": 325
            }, {
                "name": "密钥管理服务",
                "value": 306
            }, {
                "name": "电子签章服务",
                "value": 268
            }, {
                "name": "动态令牌服务",
                "value": 247
            }, {
                "name": "数据存证服务",
                "value": 221
            }],
            "name": "appNumber"
        },
        // 密码服务调用趋势
        {
            "data": [
                {
                    "name": "时间戳服务",
                    "data": [{
                        "name": "08-01",
                        "value": 432
                    }, {
                        "name": "08-02",
                        "value": 421
                    }, {
                        "name": "08-03",
                        "value": 386
                    }, {
                        "name": "08-04",
                        "value": 343
                    }, {
                        "name": "08-05",
                        "value": 312
                    }, {
                        "name": "08-06",
                        "value": 268
                    }, {
                        "name": "08-07",
                        "value": 257
                    }]
                },
                {
                    "name": "协同签名服务",
                    "data": [{
                        "name": "08-01",
                        "value": 20
                    }, {
                        "name": "08-02",
                        "value": 99
                    }, {
                        "name": "08-03",
                        "value": 10
                    }, {
                        "name": "08-04",
                        "value": 50
                    }, {
                        "name": "08-05",
                        "value": 60
                    }, {
                        "name": "08-06",
                        "value": 80
                    }]
                },
                {
                    "name": "数字证书服务",
                    "data": [{
                        "name": "08-01",
                        "value": 30
                    }, {
                        "name": "08-02",
                        "value": 130
                    }, {
                        "name": "08-03",
                        "value": 120
                    }, {
                        "name": "08-04",
                        "value": 130
                    }, {
                        "name": "08-05",
                        "value": 160
                    }, {
                        "name": "08-06",
                        "value": 180
                    }, {
                        "name": "08-07",
                        "value": 200
                    }]
                }
            ],
            "name": "serverCallMonth"
        },
        // 密码服务接口调用次数排行榜
        {
            "data": [{
                value: 1236,
                name: "申请密钥",
            },
            {
                value: 1214,
                name: "加密",
            },
            {
                value: 1129,
                name: "解密",
            },
            {
                value: 925,
                name: "证书申请",
            },
            {
                value: 855,
                name: "证书变更",
            },],
            "name": "serverInterfaceCallTop"
        },
        // 密码资源--- 密码设备统计
        {
            "data": [{
                "data": [{
                    value: 1236,
                    name: "总数",
                },
                {
                    value: 1168,
                    name: "正常",
                },
                {
                    value: 68,
                    name: "异常",
                },
                {
                    value: 20,
                    name: "分组",
                }],
                name: "时间戳服务器",
            },
            {
                "data": [{
                    value: 2534,
                    name: "总数",
                },
                {
                    value: 2454,
                    name: "正常",
                },
                {
                    value: 80,
                    name: "异常",
                },
                {
                    value: 50,
                    name: "分组",
                }],
                name: "签名验签服务器",
            },
            {
                "data": [{
                    value: 2268,
                    name: "总数",
                },
                {
                    value: 2268,
                    name: "正常",
                },
                {
                    value: 0,
                    name: "异常",
                },
                {
                    value: 30,
                    name: "分组",
                }],
                name: "密码机服务器",
            },
            {
                "data": [{
                    value: 3233,
                    name: "总数",
                },
                {
                    value: 3229,
                    name: "正常",
                },
                {
                    value: 4,
                    name: "异常",
                },
                {
                    value: 50,
                    name: "分组",
                }],
                name: "协同签名服务器",
            }, {
                "data": [{
                    value: 2257,
                    name: "总数",
                },
                {
                    value: 2255,
                    name: "正常",
                },
                {
                    value: 2,
                    name: "异常",
                },
                {
                    value: 20,
                    name: "分组",
                }],
                name: "数字证书服务器",
            }],
            "name": "deviceCount"
        },
        // 密码设备类型占比
        {
            "data": [{
                name: '协同签名服务',
                value: '221'
            },
            {
                name: '时间戳服务',
                value: '100'
            },
            {
                name: '数字证书服务',
                value: '130'
            },
            {
                name: '身份认证服务',
                value: '140'
            },
            {
                name: '协同签名服务',
                value: '80'
            },
            {
                name: '电子签章服务',
                value: '140'
            },
            {
                name: '动态令牌服务',
                value: '80'
            }],
            "name": "deviceType"
        },
        // 密码资源集群
        {
            "data": [{
                cpu: "40%",
                memory: "32%",
                network: "23%",
                name: '密码服务平台'
            },
            {
                cpu: "30%",
                memory: "45%",
                network: "6%",
                name: '协同签名集群'
            },
            {
                cpu: "20%",
                memory: "50%",
                network: "6%",
                name: '时间戳集群'
            },
            {
                cpu: "10%",
                memory: "70%",
                network: "7%",
                name: '签名验签集群'
            },
            {
                cpu: "40%",
                memory: "78%",
                network: "10%",
                name: '密码机集群'
            }],
            "name": "kmsColony"
        },
        // 密码设备厂商占比
        {
            "data": [{
                value: 1, name: '陕西CA'
            },
            {
                value: 2, name: '秦御天下'
            },
            {
                value: 3, name: '信安世纪'
            },
            {
                value: 4, name: '三未信安'
            },
            {
                value: 5, name: '数盾科技'
            }],
            "name": "deviceVendor"
        },
        // 密码设备集群网络负载
        {
            "data": [
                {
                    "name": "密码服务平台",
                    "data": [{
                        "name": "08-01",
                        "value": 50
                    }, {
                        "name": "08-02",
                        "value": 20
                    }, {
                        "name": "08-03",
                        "value": 60
                    }, {
                        "name": "08-04",
                        "value": 30
                    }, {
                        "name": "08-05",
                        "value": 60
                    }, {
                        "name": "08-06",
                        "value": 80
                    }, {
                        "name": "08-07",
                        "value": 60
                    }]
                },
                {
                    "name": "时间戳集群",
                    "data": [{
                        "name": "08-01",
                        "value": 20
                    }, {
                        "name": "08-02",
                        "value": 80
                    }, {
                        "name": "08-03",
                        "value": 60
                    }, {
                        "name": "08-04",
                        "value": 50
                    }, {
                        "name": "08-05",
                        "value": 60
                    }, {
                        "name": "08-06",
                        "value": 80
                    }, {
                        "name": "08-07",
                        "value": 60
                    }]
                },
                {
                    "name": "协同签名集群",
                    "data": [{
                        "name": "08-01",
                        "value": 30
                    }, {
                        "name": "08-02",
                        "value": 60
                    }, {
                        "name": "08-03",
                        "value": 80
                    }, {
                        "name": "08-04",
                        "value": 90
                    }, {
                        "name": "08-05",
                        "value": 60
                    }, {
                        "name": "08-06",
                        "value": 80
                    }, {
                        "name": "08-07",
                        "value": 60
                    }]
                },
                {
                    "name": "签名验签集群",
                    "data": [{
                        "name": "08-01",
                        "value": 80
                    }, {
                        "name": "08-02",
                        "value": 50
                    }, {
                        "name": "08-03",
                        "value": 60
                    }, {
                        "name": "08-04",
                        "value": 80
                    }, {
                        "name": "08-05",
                        "value": 66
                    }, {
                        "name": "08-06",
                        "value": 40
                    }, {
                        "name": "08-07",
                        "value": 60
                    }]
                },
                {
                    "name": "密码机集群",
                    "data": [{
                        "name": "08-01",
                        "value": 80
                    }, {
                        "name": "08-02",
                        "value": 50
                    }, {
                        "name": "08-03",
                        "value": 20
                    }, {
                        "name": "08-04",
                        "value": 60
                    }, {
                        "name": "08-05",
                        "value": 20
                    }, {
                        "name": "08-06",
                        "value": 40
                    }, {
                        "name": "08-07",
                        "value": 60
                    }]
                }
            ],
            "name": "kmsColonyCallMonth"
        },
        // 各类密码设备运行时间
        {
            "data": [{
                value: 1236,
                name: "密码服务平台",
            },
            {
                value: 1214,
                name: "协同签名服务平台",
            },
            {
                value: 1129,
                name: "数字签名服务平台",
            },
            {
                value: 925,
                name: "身份认证服务平台",
            },
            {
                value: 855,
                name: "数据存证服务平台",
            },],
            "name": "deviceRunTime"
        },
        // 应用密钥占用数量排行
        {
            "data": [{
                value: 1531,
                name: "ECC384",
            },
            {
                value: 1379,
                name: "ECC256",
            },
            {
                value: 1017,
                name: "RSA1024",
            },
            {
                value: 887,
                name: "RSA2048",
            },
            {
                value: 565,
                name: "SM4",
            },],
            "name": "keyUseNumber"
        },
        // 平台密钥数据
        {
            "data": [{
                "data": [{
                    value: 1531,
                    name: "授权使用",
                },
                {
                    value: 1379,
                    name: "已使用",
                },
                {
                    value: 152,
                    name: "剩余",
                }],
                name: "对称密钥",
            },
            {
                "data": [{
                    value: 2500,
                    name: "授权使用",
                },
                {
                    value: 1674,
                    name: "已使用",
                },
                {
                    value: 826,
                    name: "剩余",
                }],
                name: "非对称密钥",
            },
            {
                "data": [{
                    value: 2000,
                    name: "授权使用",
                },
                {
                    value: 139,
                    name: "已使用",
                },
                {
                    value: 1861,
                    name: "剩余",
                }],
                name: "数字证书",
            }],
            "name": "keyUseData"
        },
        // 密钥类型统计
        {
            "data": [{
                "data": [{
                    name: "ECC384",
                    value: 1973
                }, {
                    name: "ECC256",
                    value: 684
                }, {
                    name: "RSA1024",
                    value: 790
                }, {
                    name: "RSA2048",
                    value: 197
                }],
                name: "非对称密钥"
            }, {
                "data": [{
                    name: "SM4",
                    value: 2345
                }, {
                    name: "SM1",
                    value: 2178
                }, {
                    name: "AES",
                    value: 982
                }, {
                    name: "DES",
                    value: 253
                }],
                name: "对称密钥"
            }],
            "name": "keysType"
        },
        // 证书数量统计
        {
            "data": [{
                name: "累计签发",
                value: 4500
            }, {
                name: "正在使用",
                value: 3211
            }, {
                name: "即将过期",
                value: 273
            }, {
                name: "撤销",
                value: 369
            }, {
                name: "冻结",
                value: 457
            }, {
                name: "已过期",
                value: 167
            },],
            "name": "certNum"
        },
        // 证书使用趋势
        {
            "data": [
                {
                    "name": "已签发",
                    "data": [{
                        "name": "08-01",
                        "value": 50
                    }, {
                        "name": "08-02",
                        "value": 20
                    }, {
                        "name": "08-03",
                        "value": 60
                    }, {
                        "name": "08-04",
                        "value": 30
                    }, {
                        "name": "08-05",
                        "value": 60
                    }, {
                        "name": "08-06",
                        "value": 80
                    }, {
                        "name": "08-07",
                        "value": 60
                    }]
                },
                {
                    "name": "已吊销",
                    "data": [{
                        "name": "08-01",
                        "value": 2
                    }, {
                        "name": "08-02",
                        "value": 5
                    }, {
                        "name": "08-03",
                        "value": 6
                    }, {
                        "name": "08-04",
                        "value": 8
                    }, {
                        "name": "08-05",
                        "value": 10
                    }, {
                        "name": "08-06",
                        "value": 20
                    }, {
                        "name": "08-07",
                        "value": 30
                    }]
                },
                {
                    "name": "签发趋势",
                    "data": [{
                        "name": "08-01",
                        "value": 50
                    }, {
                        "name": "08-02",
                        "value": 20
                    }, {
                        "name": "08-03",
                        "value": 60
                    }, {
                        "name": "08-04",
                        "value": 30
                    }, {
                        "name": "08-05",
                        "value": 60
                    }, {
                        "name": "08-06",
                        "value": 80
                    }, {
                        "name": "08-07",
                        "value": 60
                    }]
                },
            ],
            "name": "certUseCallWeek"
        },
        // 各类密码设备运行时间
        {
            "data": [{
                value: 1236,
                name: "签名验签服务平台",
            },
            {
                value: 1214,
                name: "密码服务中台",
            },
            {
                value: 1129,
                name: "密钥管理平台",
            },
            {
                value: 925,
                name: "数据存证服务平台",
            },
            {
                value: 855,
                name: "密码实训平台",
            },],
            "name": "appInterfaceCallTop"
        },
        // 应用类型占比
        {
            "data": [{
                name: '服务端',
                value: '317'
            },
            {
                name: '小程序',
                value: '34'
            },
            {
                name: '移动端',
                value: '45'
            }],
            "name": "appType"
        },
        // 新增应用数量统计
        {
            "data": [{
                name: '8.7',
                value: '7'
            },
            {
                name: '8.8',
                value: '8'
            },
            {
                name: '8.9',
                value: '9'
            },
            {
                name: '8.10',
                value: '10'
            },
            {
                name: '8.11',
                value: '11'
            },
            {
                name: '8.12',
                value: '10'
            },
            {
                name: '8.13',
                value: '11'
            }],
            "name": "addAppNumber"
        },
        // 应用请求反应耗时
        {
            "data": [{
                name: "签名验签",
                value: "35",
            },
            {
                name: "数据存证",
                value: "35",
            },
            {
                name: "申请密钥",
                value: "35",
            },
            {
                name: "身份认证",
                value: "35",
            }, {
                name: "动态令牌",
                value: "35",
            },
            {
                name: "时间戳",
                value: "35",
            },
            {
                name: "协同签名",
                value: "35",
            },
            {
                name: "密钥管理",
                value: "35",
            }],
            "name": "appRequestTime"
        },
        // 密码应用状态评分
        {
            "data": [{
                name: '签名验签',
                value: '90'
            },
            {
                name: '密钥管理',
                value: '98'
            },
            {
                name: '数据存证',
                value: '80'
            }],
            "name": "appStatusScore"
        },
        // 实时活跃应用个数
        {
            "data": [{
                "name": "10:10:00",
                "value": 150
            }, {
                "name": "10:10:10",
                "value": 80
            }, {
                "name": "10:10:20",
                "value": 120
            }, {
                "name": "10:10:30",
                "value": 130
            }, {
                "name": "10:10:40",
                "value": 160
            }, {
                "name": "10:10:50",
                "value": 180
            }, {
                "name": "10:10:60",
                "value": 200
            }, {
                "name": "10:11:00",
                "value": 120
            }, {
                "name": "10:11:10",
                "value": 123
            }, {
                "name": "10:11:20",
                "value": 150
            }, {
                "name": "10:11:30",
                "value": 180
            }],
            "name": "RealTimeActiveAppNumber"
        },
        // 应用系统中间大图
        {
            "data": [
                {
                    "name": "协同签名服务",
                    "data": [{
                        "name": "签名验签服务器",
                        "value": 2466
                    }, {
                        "name": "时间戳服务器",
                        "value": 2321
                    }, {
                        "name": "数据存证服务器",
                        "value": 2247
                    }, {
                        "name": "协同签名服务器",
                        "value": 2213
                    }, {
                        "name": "身份认证服务器",
                        "value": 1577
                    }, {
                        "name": "密钥管理服务器",
                        "value": 1432
                    }]
                },
                {
                    "name": "密码中台服务",
                    "data": [{
                        "name": "签名验签服务器",
                        "value": 2566
                    }, {
                        "name": "动态令牌服务器",
                        "value": 2349
                    }, {
                        "name": "数据存证服务器",
                        "value": 2254
                    }, {
                        "name": "时间戳服务器",
                        "value": 1478
                    }, {
                        "name": "证书服务器",
                        "value": 1156
                    }, {
                        "name": "密钥服务器",
                        "value": 935
                    }]
                },
                {
                    "name": "动态CA服务",
                    "data": [{
                        "name": "申请证书",
                        "value": 1934
                    }, {
                        "name": "证书延期",
                        "value": 1543
                    }, {
                        "name": "证书变更",
                        "value": 1322
                    },]
                }
            ],
            "name": "accessAppNumber"
        },

    ],
    "msg": "成功"
}